import React from 'react';
import { DragSource } from 'react-dnd';
import PropTypes from 'prop-types';

export function DraggableWrapperComponent({ children, connectDragSource, id, isDragging }) {
  // Since this is dynamic. Should leave or use classes?
  // Should we add opacity defaults to api/theme?
  const style = {
    opacity: isDragging ? 0.25 : 1
  };
  return connectDragSource(
    <div id={id} style={style}>
      {children}
    </div>
  );
}

/* istanbul ignore next */
const source = {
  beginDrag({ currentRow, id }) {
    return {
      currentRow,
      id
    };
  },
  endDrag(props, monitor) {
    if (!monitor.didDrop()) {
      return;
    }
    const { currentRow, handleDrop } = props;
    const { dropRow, size } = monitor.getDropResult();
    handleDrop(currentRow, dropRow, size);
  },
  canDrag(props) {
    return props.canDrag !== false;
  }
};

/* istanbul ignore next */
const collect = (connect, monitor) => ({
  connectDragSource: connect.dragSource(),
  isDragging: monitor.isDragging()
});

DraggableWrapperComponent.defaultProps = {
  isDragging: false
};

DraggableWrapperComponent.propTypes = {
  connectDragSource: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  id: PropTypes.number,
  isDragging: PropTypes.bool
};

export default DragSource('WIDGET', source, collect)(DraggableWrapperComponent);
